import { useState } from 'react'

import { Button, Input } from '@/components/ui'
import { formatMonth, formatPeriod, sameMonthFiled } from './period'
import { StatementField } from './StatementField'
import type { DatePeriod } from './types'

const FIELD_HEIGHT = 'h-7'

// Wide enough that Chrome's own calendar button sits inside the border next to the date.
const DATE_BOX = `${FIELD_HEIGHT} w-36 px-2 text-xs shadow-none`

interface PeriodFieldProps {
  period: DatePeriod | null
  onChange: (period: DatePeriod) => void
}

export const PeriodField = ({ period, onChange }: PeriodFieldProps) => {
  const [draft, setDraft] = useState<DatePeriod | null>(null)

  const movesTo =
    draft?.end && (!period || !sameMonthFiled(draft, period))
      ? formatMonth(draft.end)
      : null

  if (draft) {
    return (
      <div className="flex flex-wrap items-center gap-1.5">
        <Input
          type="date"
          value={draft.start}
          onChange={(event) =>
            setDraft({ ...draft, start: event.target.value })
          }
          className={DATE_BOX}
        />
        <span className="text-xs text-ink-subtle">to</span>
        <Input
          type="date"
          value={draft.end}
          onChange={(event) => setDraft({ ...draft, end: event.target.value })}
          className={DATE_BOX}
        />
        <Button
          size="xs"
          className={FIELD_HEIGHT}
          onClick={() => {
            onChange(draft)
            setDraft(null)
          }}
        >
          Save
        </Button>
        <Button
          size="xs"
          theme="ghost"
          className={FIELD_HEIGHT}
          onClick={() => setDraft(null)}
        >
          Cancel
        </Button>
        {movesTo ? (
          <span className="text-xs text-ink-subtle">
            Files it under {movesTo}.
          </span>
        ) : null}
      </div>
    )
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <StatementField
        field="dates"
        missing={!period}
        title="Correct the dates this statement covers"
        onClick={() => setDraft(period ?? { start: '', end: '' })}
      >
        {formatPeriod(period)}
      </StatementField>
    </div>
  )
}
